module.exports = __webpack_public_path__ + "static/media/Bolsa2.32330e9d.jpg";